<script>
  import Icon from '@iconify/svelte';
  import plus16 from '@iconify/icons-octicon/plus-16';
  import trash16 from '@iconify/icons-octicon/trash-16';
	export let shafts=[];
  export let text="Output shafts position, speed and tolerances";
  export let max_items=1;

  function addMoreShafts(event) {
    if( shafts.length < max_items ) {
		  shafts[shafts.length] = { x: '', xt:'', y: '', yt:'', v: '', vt: '' };
    }
	}
  function removeShaft(event) {
    if (shafts.length > 1) {
		  shafts.splice(Number(event.target.attributes.getNamedItem("name").value),1)
      shafts=shafts
    } else {
      shafts=[];
      shafts[shafts.length] = { x: '', xt:'', y: '', yt:'', v: '', vt: '' };
    }
	}
</script>

<div class="head">
  {text}
  {#if shafts.length < max_items}
    <button on:click="{addMoreShafts}"> <Icon icon={plus16} inline={true} /> Add more </button>
  {/if}
  
</div>
{#each shafts as shaft, num }
  <div>#{num}
    <div class="tooltip">
        x=<input type="number" step="0.01" min="-1000" max="1000" name="x-{num}" bind:value={shaft.x} required />
        ±<input type="number" step="0.01" min="0.01" max="1000" name="xt-{num}" bind:value={shaft.xt} required/>mm
      <span class="tooltiptext">Horizontal distance of #{num} from the origin in mm. Negative numbers denote left of the origin. Tolerance is absolute in mm.</span>
    </div>
    <div class="tooltip">
        y=<input type="number" step="0.01" min="-1000" max="1000" name="y-{num}" bind:value={shaft.y} required />
        ±<input type="number" step="0.01" min="0.01" max="1000" name="yt-{num}" bind:value={shaft.yt} required/>mm
      <span class="tooltiptext">Vertical distance of #{num} from the origin in mm. Use Negative numbers to denote position under the origin. Tolerance is absolute.</span>
    </div>  
    <div class="tooltip">
        v=<input type="number" step="1" min="-10000" max="10000" name="v-{num}" bind:value={shaft.v} required />rpm
        ±<input type="number" step="0.1" min="0.1" max="10" name="vt-{num}" bind:value={shaft.vt} required/>%
      <span class="tooltiptext"> Rotations per minute for #{num}. Negative numbers denote clockwise rotations. Tolerance is relative.</span>
    </div>  
    <div name={num} class="tooltip" on:click="{removeShaft}">
      <Icon icon={trash16} name={num} inline={true} />
      <span class="tooltiptextleft"> Remove this data row...</span>
    </div>
  </div>
{/each}


<style>

  



  
  .head { 
    /*max-height: 20 px;*/
    background-color: #6baed6;
    color: white;
    font-size: 20px;
    text-align: center;
    padding: 0px;
  }
  
  


 
  
 

 
  

  
  
 
 
  
 
  
 
  input[type=number] {
    width: 50px;
    text-align: right;
  }
  
  
  
  
  
  
 
  

  
  .tooltip {
    position: relative;
    display: inline-block;
    border: 1px dotted black;
  }
  

  .tooltiptext {
    font-size: small;
  }

  .tooltiptextleft {
    font-size: small;
  }
  
  .tooltip .tooltiptextleft {
    visibility: hidden;
    width: 10ex;
    background-color: rgb(255, 255, 216);
    color: black;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 135%;
    left: 40%;
    margin-left: -40px;
    opacity: 0;
    transition: opacity 1s;
  }
  .tooltip .tooltiptextleft::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgb(255, 255, 216) transparent;
  }
  
  .tooltip:hover .tooltiptextleft {
    visibility: visible;
    opacity: 1;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 45ex;
    background-color: rgb(255, 255, 216);
    color: black;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 135%;
    left: 40%;
    margin-left: -100px;
    opacity: 0;
    transition: opacity 1s;
  }
  
  .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgb(255, 255, 216) transparent;
  }
  
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
  
 
  
 
  

  
</style>